export default __webpack_public_path__ + "static/media/logo-green.b0f804cb.svg";